import { usePageTitleTranslation } from 'libs/navigation';

import { useCreateClient } from '../hooks/useCreateClient';
import { CreateClientView } from '../views';

export const CreateClientContainer = () => {
  const { onSubmit, formError, submitLoading } = useCreateClient();

  usePageTitleTranslation('client.createClient.title');

  return (
    <CreateClientView
      formError={formError}
      submitLoading={submitLoading}
      onSubmit={onSubmit}
    />
  );
};
